import { initComponent } from './core/init-component';
import Swiper from 'swiper';

const mql = window.matchMedia('(max-width: 1023px)');

initComponent('.js-ls-product-card__swiper', (el) => {
  const card = el.closest<HTMLElement>('.js-ls-product-card');
  if (card?.hasAttribute('data-disable-swiper')) return;

  const cardLink = card?.querySelector<HTMLAnchorElement>('.js-ls-product-card__link') ?? null;
  const cardUrl = cardLink?.href ?? card?.dataset.url ?? null;

  let swiper: Swiper | null = null;

  function navigateToProduct(url: string, event?: MouseEvent | TouchEvent | PointerEvent) {
    if (
      event instanceof MouseEvent &&
      (event.ctrlKey || event.metaKey || event.button === 1)
    ) {
      event.preventDefault();
      window.open(url, '_blank', 'noopener');
      return;
    }

    window.location.href = url;
  }

  function initSwiper() {
    if (cardLink) cardLink.style.pointerEvents = 'none';

    swiper = new Swiper(el, {
      slidesPerView: 1,
      // Set by the card when a PLP colour filter is active: start on that colour's image.
      initialSlide: Number(card?.dataset.initialSlide ?? 0),
      on: {
        click(_, event) {
          if (cardUrl) navigateToProduct(cardUrl, event);
        },
      },
    });
  }

  function destroySwiper() {
    if (swiper) {
      swiper.destroy(true, true);
      swiper = null;
    }
    if (cardLink) cardLink.style.pointerEvents = '';
  }

  function onBreakpointChange() {
    if (mql.matches) {
      if (!swiper) initSwiper();
    } else {
      destroySwiper();
    }
  }

  mql.addEventListener('change', onBreakpointChange);

  if (mql.matches) initSwiper();

  return {
    unload() {
      mql.removeEventListener('change', onBreakpointChange);
      destroySwiper();
    },
  };
});
